import { IconButton, SxProps, useTheme } from "@mui/material";

// eslint-disable-next-line

import { forwardRef } from "react";

import Iconify from "../iconify/Iconify";
import { enqueueSnackbar } from "../snackbar";

type Props = {
  source: string;
  height?: string;
  sx?: SxProps;
  color?: any;
};

const CopyButton = forwardRef(function CopyButton(props: Props, ref: any) {
  const theme = useTheme();
  const onClick = async () => {
    try {
      await doCopy(props.source);
      enqueueSnackbar("Copied successed", {
        variant: "success",
        key: new Date().getTime().toString(),
      });
    } catch (e: any) {
      enqueueSnackbar(e.message ?? "Copied failed", { variant: "error" });
    }
  };
  return (
    <IconButton
      onClick={onClick}
      ref={ref}
      {...props}
      sx={{
        p: 0,
        marginLeft: "8px",
        height: props.height || "32px",
        width: props.height || "32px",
        borderRadius: "50%",
        ...props.sx,
      }}
    >
      <Iconify
        icon="icon-park-outline:copy"
        width={20}
        fontSize={20}
        color={props?.color || theme.palette.text.primary}
      />
    </IconButton>
  );
});

export default CopyButton;

async function doCopy(text: string) {
  if (
    window.location.protocol === "http:" &&
    window.location.hostname !== "localhost"
  )
    throw new Error("can not copy without ssl context.");
  if (!navigator.clipboard) throw new Error("can not access clipboard!");
  await navigator.clipboard.writeText(text);
}
